export default class TextFormatter {
    static getImageURL = (url) => {
        if(!url){
            return null
        }
        return url.includes("patient_attachment-") ? `${process.env.REACT_APP_NEO_USER_API_PROD_CONFIG}/api/image?image_name=${url}` : url
    }
}
